import { flow, map, isObject, sortBy, get, deburr, toLower } from 'lodash/fp';
import encodeName from './encodeName';

const prepareOptions = (items, { stringifyValues = true } = {}) =>
  flow(
    map((item) =>
      isObject(item) ? item : { value: stringifyValues ? String(item) : item },
    ),
    map(({ value, label, ...props }) => {
      label = label || String(value);

      return { ...props, label, value, name: encodeName(value) };
    }),
  )(items);

export const prepareSortedOptions = flow(
  prepareOptions,
  sortBy(flow(get(['label']), deburr, toLower)),
);

export default prepareOptions;
